import { createTheme, PaletteMode } from '@mui/material';
import { blue, green, red } from '@mui/material/colors';

declare module '@mui/material/styles' {
  interface Palette {
    neutral: Palette['primary'];
    tertiary: Palette['primary'];
  }

  // allow configuration using `createTheme`
  interface PaletteOptions {
    neutral?: PaletteOptions['primary'];
    tertiary?: PaletteOptions['primary'];
  }
}

// Update the Button's color prop options
declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    neutral: true;
    tertiary: true;
  }
}

const useTheme = (themeSetting: PaletteMode) => {
  return createTheme({
    palette: {
      mode: themeSetting,
      primary: blue,
      secondary: red,
      tertiary: {
        main: green[500],
        contrastText: '#fff',
      },
      error: red,
      background: {
        default: '#fff',
      },
      neutral: {
        main: '#616161',
        contrastText: '#fff',
      },
    },
    typography: {
      fontSize: 12,

      h6: {
        fontWeight: 300,
      },
    },
  });
};

export default useTheme;
